import { ContextBarItem, DashboardIcon, HouseIcon, ShipIcon } from '@sailadv/hdata-ui';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectBoat, useSelectedBoat } from '@/entities/boat';
import { useIsPlant } from '@/entities/user';

import { ScopeMenu } from '../scope-menu';

export const ScopeSwitcher = () => {
	const { t } = useTranslation('common');
	const isPlant = useIsPlant();
	const boats = useSelector(selectBoat.selectAll);
	const selectedBoat = useSelectedBoat();
	const BoatIcon = isPlant ? HouseIcon : ShipIcon;
	const [firstBoat] = boats;

	if (boats.length === 1) {
		return <ContextBarItem icon={<BoatIcon />}>{firstBoat.name}</ContextBarItem>;
	}

	if (!boats.length) {
		return <ContextBarItem icon={<DashboardIcon />}>{t('contextBar.fleet')}</ContextBarItem>;
	}

	return (
		<ContextBarItem
			icon={selectedBoat ? <BoatIcon /> : <DashboardIcon />}
			menu={<ScopeMenu boats={boats} selectedId={selectedBoat?.id} />}
		>
			{selectedBoat?.name ?? t('contextBar.fleet')}
		</ContextBarItem>
	);
};
